import React, { useState } from 'react'
import { Dimensions, Platform, Pressable, ScrollView, Text, View } from 'react-native'
import { ScaledSheet } from 'react-native-size-matters'
import {
  ApiChecker,
  AudioRecordingChecker,
  // FirebaseAnalyticsChecker,
  FirebaseAuthenticationChecker,
  FirebaseFirestoreChecker,
  // FirebaseRemoteConfigChecker,
  FirebaseStorageChecker,
} from '~components/diagnostics/checkers'
import { Theme } from '~theme'
import { useTheme } from '~theme/ThemeManager'

export default function DiagnosticsScreen(): React.JSX.Element {
  const { theme } = useTheme()
  const styles = getStyles(theme)
  const [cleared, setCleared] = useState(false)

  const clearBrowserStorage = async () => {
    try {
      await indexedDB.databases().then((databases) => {
        databases.forEach((database) =>
          database.name ? indexedDB.deleteDatabase(database.name) : Promise.resolve(),
        )
      })
      setCleared(true)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ScrollView>
      <View style={styles.container}>
        <Text style={styles.title}>
          A series of tests are being performed to check your device can access resources required
          by the app.
        </Text>
        <View>
          <ApiChecker />
          {/* <FirebaseAnalyticsChecker />
        <FirebaseRemoteConfigChecker /> */}
          <FirebaseAuthenticationChecker />
          <FirebaseFirestoreChecker />
          <FirebaseStorageChecker />
          {Platform.OS === 'web' && <AudioRecordingChecker />}
        </View>
        <View style={styles.keyContainer}>
          <View style={styles.keyInner}>
            <View style={[styles.circle, styles.circleFailed]} />
            <Text style={styles.keyText}>Failure</Text>
          </View>
          <View style={styles.keyInner}>
            <View style={[styles.circle, styles.circleWarning]} />
            <Text style={styles.keyText}>In Progress</Text>
          </View>
          <View style={styles.keyInner}>
            <View style={[styles.circle, styles.circleSuccess]} />
            <Text style={styles.keyText}>Success</Text>
          </View>
        </View>
        <View style={styles.keyContainer}>
          <Pressable onPress={clearBrowserStorage}>
            <Text>
              {cleared ? 'Browser Storage Cleared' : 'Clear Browser Storage (force logout)'}
            </Text>
          </Pressable>
        </View>
      </View>
    </ScrollView>
  )
}

const getStyles = (theme: Theme) =>
  ScaledSheet.create({
    container: {
      width: Dimensions.get('window').width < 640 ? '90%' : '60%',
      alignSelf: 'center',
      padding: '5@mvs',
    },
    title: {
      textAlign: 'center',
      paddingVertical: '10@mvs',
    },
    keyContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
    },
    keyInner: {
      flexDirection: 'row',
      paddingHorizontal: '5@s',
      paddingVertical: '5@s',
      alignItems: 'center',
    },
    keyText: {
      fontSize: '10@ms0.4',
    },
    circle: {
      width: '12@s',
      height: '12@s',
      borderRadius: '12@s',
      marginRight: '3@s',
    },
    circleSuccess: {
      backgroundColor: '#10B981',
    },
    circleWarning: {
      backgroundColor: '#F59E0B',
    },
    circleFailed: {
      backgroundColor: '#EF4444',
    },
  })
